var _path, _path2, _path3, _path4, _polygon, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBannerHi = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 402.1 307.1"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M138.1,155.6l1.2.8.9.7h.4v-28.3h10.2v26.8l1.2.8.9.7h.4v-28.3h22.1v8.3h-7.1c-4.6,0-7.4,2.8-7.4,6.6s3.7,10.1,5.8,12.9l1.5-.8c-2.7-3.4-4.9-7.4-4.9-10.8s2.2-5.5,6.1-5.5h6.1c0,11.7,0,16.1,0,16.1l1.2.8.9.7h.4v-28.3h12.5v10.5c0,1.1-.8,1.6-1.9,1.6s-1.7-.2-2.5-.6l-1.4,1.4c.5,1.3,1.6,3.7,5.5,8.8l5,6.6,2-1.1c-5.9-6-8.7-10.4-8.7-11.2s.3-.5.6-.7c2.8-1.7,3.9-2.9,3.9-5.9v-9.5h6.5v-.3l-.7-.8-.8-1.2h-44.7c-3.7-9.1-8.1-12-11.5-12s-4.8,2.2-4.8,4.6,1.2,3.9,2.6,4.8l1.2-.4c-.8-1-1.4-2.3-1.4-3.4,0-1.7,1.1-3.2,3.2-3.2s6.3,2.5,9.2,9.6h-20v.3l.7.8.8,1.2h4.9v11.7h-10.8v-9.1c0-1.7-.7-2.6-2-3.7-1.2-1-2.3-1.4-3.4-1.4s-2.3.3-3.2,1.1l1.5,2.7c.8-1,2-1.5,3.3-1.5s1.3.4,1.3.9v4.1c0,4.6,0,6.6,0,6.6-1.3.6-1.8.9-1.8,1.7,0,1.5,1.5,4,2.7,5.3h1.5v-4.5h10.9c0,9.3,0,12.8,0,12.8Z",
  fill: "#fff"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M210.5,128.8h15.5v4c0,1-.3,1.3-6.6,2.9-4.7,1.2-6.7,3.5-6.7,6.4,0,5.3,6.3,9.8,11.4,9.8s2.8,0,4-.7l2.9,7.3,2.5-.7-4-7.3c.8-.6,1.2-1.2,1.2-2,0-1.5-1.7-2.4-3.7-3.9l-1.2.8,1.3,3.3c-.5.3-1.7.9-4.4.9-5.1,0-7.7-3.4-7.7-6.2s1.4-4.3,5.2-5.4l3.9-1.1c4.1-1.2,4.3-1.9,4.3-3.4v-4.7h12.1v9.8c0,1.2-.9,1.6-2.1,1.6s-1.7-.3-2.2-.6l-1.5,1.4c3.6,8.4,9.5,13.4,16.8,13.4s7.8-1.7,9.8-3.3l-.2,4.6,1.1.8.8.7h.4v-28.3h10.2v26.8l1.2.8.9.7h.4v-28.3h6.4v-.3l-.7-.8-.8-1.2h-5.3l-2-3.3c-4.8-7.8-6.6-8.7-9.5-8.7s-1.9.2-2.8.7l1.6,2.6c.7-.4,1.6-.7,2.4-.7,2.8,0,4.4,2.3,6.8,6.2l1.9,3.2h-46.2l-2-3.3c-4.8-7.8-6.6-8.7-9.5-8.7s-1.9.2-2.8.7l1.6,2.6c.7-.4,1.6-.7,2.4-.7,2.8,0,4.4,2.3,6.8,6.2l1.9,3.2h-17.5v.3l.7.8.8,1.2ZM243.1,137.8v-9h18.3v12c-.8,1.3-2.9,3.2-6.2,3.2s-5.2-2.6-5.2-4.7,1.8-4.4,4.7-4.4,2.4.4,3.6,1.1h.2c0-.1-.8-2.5-.8-2.5-.8-.4-1.9-1-4-1-3.4,0-5.8,2.3-5.8,5.5s3.5,8,8.1,8,5.1-1.8,5.7-2.5c0,0-.2,2.1-.2,4.1v.9c-1.2,1.1-5,3.6-10.6,3.6-9.2,0-12-7.4-12-8s.1-.4.7-.8c2.9-1.9,3.5-3.1,3.5-5.6Z",
  fill: "#fff"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M174.2,183.2h3.5v3.1c0,2.4,0,4.2,0,6.3-1.5.8-2.1.9-2.1,1.8,0,1.5,1.8,4.2,3.1,5.4h1.5v-16.6h9.8v26.8l1.2.8.9.7h.4v-28.3h6.4v-.3l-.7-.8-.8-1.2h-5.3l-2-3.3c-4.8-7.8-6.6-8.7-9.5-8.7s-1.9.2-2.8.7l1.6,2.6c.7-.4,1.6-.7,2.4-.7,2.8,0,4.4,2.3,6.8,6.2l1.9,3.2h-44.5v.3l.7.8.8,1.2h5.2v8.8c0,1.9-.8,2.7-3.6,2.7s-6-1.3-7.3-2.1c1.9-1.1,3.1-2.6,3.1-4.9,0-3.4-4-6.9-8.8-6.9s-3.4.3-4.9,1.1l1.9,2.4c1.4-.8,3-1.3,4.5-1.3,2.8,0,5,1.2,5,4s-3.4,4.4-7.8,5.2l1.6,2.2c1.6-.3,3-.7,4.2-1.1,1.9,1.2,3.2,3.2,3.2,5.3s-1.6,4.7-4.7,4.7-7-2.9-9.1-7.4l-1.4.8c2.8,5.6,6.9,9,11.3,9s6.4-2.8,6.4-6-.6-3.1-1.2-4c2.2.8,3.7,1.4,5.2,1.4s1.8-.1,2.6-.6v13.9l1.2.8.9.7h.4v-28.3h10.2v26.8l1.2.8.9.7h.4v-28.3h6.4Z",
  fill: "#fff"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M228.8,201c0,5.5-.2,9-.2,9l1.2.8.9.7h.4v-28.3h20.6v3.6c0,.8-.1,1.1-2.4,1.9l-5.7,1.9c-3.8,1.3-5.4,3.7-5.4,6.4,0,5.9,6.8,11.4,12.8,11.4s6.8-2.8,6.8-5.6-3-6.2-6.3-6.2-4.9,1.9-4.9,4.5,1.6,4.1,2.7,5.1c-5.3-.4-8.7-4.2-8.7-8s1.4-4.5,4.9-5.7l5.3-1.8c2.5-.8,3.4-1.6,3.4-3.1v-4.5h10v26.8l1.2.8.9.7h.4v-28.3h6.4v-.3l-.7-.8-.8-1.2h-5.3l-2-3.3c-4.8-7.8-6.6-8.7-9.5-8.7s-1.9.2-2.8.7l1.6,2.6c.7-.4,1.6-.7,2.4-.7,2.8,0,4.4,2.3,6.8,6.2l1.9,3.2h-56v.3l.7.8.8,1.2h18.5v12.5c0,2-.9,3.8-2.3,4.9l-8.8-9.7c.9-.5,1.9-.8,3-.8,2.1,0,3.4.6,4.1.9l.3-.3-1.1-2.3c-.7-.3-1.9-.8-4-.8-4,0-7.5,3.2-7.5,7.2s1.3,4.7,2.8,6.4c1.7,1.9,3.8,3.4,6.8,3.4s6.2-2.1,7-3.7ZM248.9,202c0-2,1.4-3.4,3.6-3.4s3.2,1.4,3.2,3.2-1.4,4.3-5,4.5c-1.1-1.1-1.8-2.8-1.8-4.3ZM221,202.6c-4.2,0-6.6-3.5-6.6-6.5s.7-3.2,1.8-4.3l8.8,9.7c-1.2.7-2.6,1.1-4,1.1Z",
  fill: "#fff"
})), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "244.3 218.6 246.6 216.2 244.2 213.9 241.9 216.2 244.3 218.6",
  fill: "#fff"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M292.5,134.1c.2.1.4.2.6.2.4,0,.7-.2.9-.5.3-.5.1-1.2-.4-1.5h0c-.5-.3-1.2-.2-1.5.4-.3.5-.1,1.2.4,1.5Z",
  fill: "#fff"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M300.7,139.6c.3,0,.7-.1.9-.4.4-.5.3-1.2-.2-1.5h0c-.5-.4-1.1-.3-1.5.2-.4.5-.2,1.2.3,1.6.2.2.4.2.7.2Z",
  fill: "#fff"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M307.3,145.1c.2.2.4.2.7.2s.6-.1.9-.4c.4-.5.3-1.2-.2-1.5h0c-.5-.4-1.2-.4-1.5.1-.4.5-.3,1.2.2,1.5h0Z",
  fill: "#fff"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M321.8,156.8c.2.2.4.2.7.2s.6-.1.9-.4c.4-.5.3-1.2-.2-1.5h0c-.5-.4-1.2-.4-1.5.1-.4.5-.3,1.2.2,1.5h.1Z",
  fill: "#fff"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M314.6,151l.7-.9.7-.9-.7.8.7-.9c-.5-.4-1.2-.3-1.5.2-.4.5-.3,1.2.2,1.5h0Z",
  fill: "#fff"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M329.7,162.8c.3,0,.7-.2.9-.5.3-.5.2-1.2-.3-1.5h0c-.5-.4-1.2-.2-1.5.3-.3.5-.2,1.2.3,1.5.2.1.4.2.6.2Z",
  fill: "#fff"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M109.9,127.8c-.4.5-.2,1.2.3,1.5h0c.2.2.4.2.6.2.3,0,.7-.2.9-.5.4-.5.2-1.2-.3-1.5-.5-.4-1.2-.2-1.5.3Z",
  fill: "#fff"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M97.3,118.6c-.4.5-.3,1.2.2,1.5h0c.2.2.4.3.6.3.3,0,.7-.2.9-.5.4-.5.2-1.2-.3-1.6-.5-.4-1.2-.3-1.5.2Z",
  fill: "#fff"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M103.6,123.2c-.4.5-.3,1.2.2,1.5,0,0,0,0,0,0,.2.1.4.2.6.2.3,0,.7-.2.9-.5.4-.5.2-1.2-.3-1.6-.5-.4-1.2-.3-1.5.2Z",
  fill: "#fff"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M91.2,114c0,0,0,.2-.1.3-.3.5-.2,1,.3,1.3.2,0,.4.2.6.2s.2,0,.3,0c.3,0,.5-.2.7-.4.4-.5.2-1.2-.2-1.6-.5-.4-1.2-.3-1.5.2Z",
  fill: "#fff"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M217.6,85.6c.2,0,.4.2.6.2.4,0,.7-.2.9-.5.3-.5.2-1.2-.4-1.5-.5-.3-1.2-.2-1.5.4-.3.5,0,1.1.4,1.4Z",
  fill: "#fff"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M211.2,81.7c.2.1.4.2.6.2.4,0,.7-.2.9-.5.3-.5.1-1.2-.4-1.5s-1.2,0-1.5.4c-.3.5-.1,1.1.4,1.4Z",
  fill: "#fff"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M204.4,77.6c.2,0,.4.2.5.2.4,0,.7-.2.9-.5.3-.5.1-1.2-.4-1.5-.5-.3-1.2-.1-1.5.4-.2.5,0,1.1.5,1.4Z",
  fill: "#fff"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M197.5,73.6c.2,0,.4,0,.5,0,.4,0,.7-.2.9-.5.3-.5,0-1.2-.4-1.5-.5-.3-1.2,0-1.5.4-.2.5,0,1.2.5,1.5Z",
  fill: "#fff"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M190.7,69.6c.2,0,.4,0,.5,0,.4,0,.7-.2.9-.5.3-.5,0-1.2-.4-1.5-.5-.3-1.2,0-1.5.4-.2.5,0,1.2.5,1.5Z",
  fill: "#fff"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M183.8,65.6c.2,0,.3,0,.5,0,.4,0,.7-.2.9-.5.3-.5.1-1.2-.4-1.5s-1.2,0-1.5.4c-.2.6-.1,1.2.5,1.5Z",
  fill: "#fff"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M176.8,61.7c.2.1.3.1.5.1.4,0,.7-.2.9-.5.3-.5.1-1.2-.4-1.5s-1.2-.1-1.5.4c-.2.6,0,1.2.5,1.5Z",
  fill: "#fff"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M169.9,57.9c.2.1.3.1.5.1.4,0,.7-.2.9-.6.3-.5.1-1.2-.4-1.5s-1.2,0-1.5.4c-.3.6,0,1.3.5,1.6Z",
  fill: "#fff"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M162.9,54.1c.2,0,.3,0,.5,0,.4,0,.8-.2.9-.6.3-.5.1-1.2-.4-1.5s-1.2,0-1.5.4c-.3.6,0,1.3.5,1.6Z",
  fill: "#fff"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M155.8,50.3c.2,0,.3,0,.5,0,.4,0,.8-.2.9-.6.3-.5.1-1.2-.4-1.4-.5-.3-1.2,0-1.4.4-.3.6,0,1.3.4,1.5Z",
  fill: "#fff"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M374.8,258.1c0-.6-.4-1.1-1-1.2-.6,0-1.1.4-1.1,1,0,.6.3,1.2,1,1.2s1-.4,1.1-1Z",
  fill: "#fff"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M365.8,258.2c.5,0,1-.4,1.1-.9.1-.6-.3-1.1-.9-1.2-.6,0-1.1.3-1.2.9-.1.6.3,1.1.9,1.2h.1Z",
  fill: "#fff"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M389.5,258h.3c.6-.2.9-.8.7-1.3-.2-.6-.8-.9-1.3-.7-.6.2-.9.8-.7,1.3.1.4.5.7,1,.7Z",
  fill: "#fff"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M357.9,256.7c.5,0,.9-.3,1-.9.1-.6-.2-1.1-.8-1.3-.6-.1-1.1.2-1.3.8,0,.6.2,1.1.8,1.3.2.1.3.1.3.1Z",
  fill: "#fff"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M350.2,254.9c.5,0,.9-.3,1-.8.1-.6-.2-1.2-.8-1.3-.6-.1-1.2.2-1.3.8,0,.6.2,1.2.8,1.3h.3Z",
  fill: "#fff"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M395.6,253.9c.2.2.5.3.7.3.3,0,.6,0,.8-.3.4-.4.4-1.1-.1-1.5-.4-.4-1.1-.4-1.5.1-.4.3-.4.9.1,1.4Z",
  fill: "#fff"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M342.5,252.8c.5,0,.9-.3,1-.8.2-.6-.2-1.2-.7-1.3-.6-.2-1.2.2-1.3.7-.2.6.2,1.2.7,1.3.1.1.2.1.3.1Z",
  fill: "#fff"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "M334.9,250.5c.5,0,.9-.3,1-.7.2-.6,0-1.2-.7-1.3-.6-.2-1.2,0-1.3.7-.2.6.1,1.2.7,1.3h.3Z",
  fill: "#fff"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "M327.3,248c.4,0,.9-.3,1-.7.2-.6-.1-1.2-.7-1.4-.6-.2-1.2.1-1.4.7-.2.6.1,1.2.7,1.4h.4Z",
  fill: "#fff"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M398.1,245.8c0,.6.4,1.1,1,1.1h0c.6,0,1-.4,1.1-1,0-.6-.4-1.1-1-1.1-.6-.1-1.1.4-1.2,1Z",
  fill: "#fff"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M319.8,245.3c.4,0,.8-.3,1-.7.2-.6-.1-1.2-.6-1.4-.6-.2-1.2,0-1.4.6-.2.6,0,1.2.6,1.4.2,0,.3,0,.4,0Z",
  fill: "#fff"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  d: "M398,239.1c.1,0,.2,0,.3,0,.6-.2.9-.8.7-1.4s-.8-.9-1.4-.7c-.6.2-.9.8-.7,1.4.2.5.6.8,1.1.8Z",
  fill: "#fff"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  d: "M394.7,231.8c.2,0,.3,0,.5-.1.5-.3.7-.9.4-1.4s-.9-.7-1.4-.4c-.4.2-.6.8-.4,1.3.2.4.6.6.9.6Z",
  fill: "#fff"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  d: "M390.7,225c.2,0,.4-.1.6-.2.5-.3.6-1,.3-1.5s-1-.6-1.5-.3c-.5.3-.6,1-.3,1.5.2.3.6.5.9.5Z",
  fill: "#fff"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  d: "M386.1,218.5c.2,0,.5-.1.6-.2.5-.4.6-1,.2-1.5-.4-.5-1-.6-1.5-.2s-.6,1-.2,1.5c.3.2.6.4.9.4Z",
  fill: "#fff"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  d: "M381.1,212.3c.2,0,.5-.1.7-.2.5-.4.5-1.1,0-1.5-.4-.5-1.1-.5-1.5,0-.5.4-.5,1.1,0,1.5.2,0,.5.3.8.3Z",
  fill: "#fff"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  d: "M375.9,206.2c.3,0,.5,0,.7-.3.4-.4.5-1.1.1-1.5-.4-.4-1.1-.5-1.5,0-.4.4-.5,1.1-.1,1.5.2.3.5.4.8.4Z",
  fill: "#fff"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  d: "M370.5,200.4c.3,0,.5,0,.7-.3.4-.4.4-1.1,0-1.5-.4-.4-1.1-.4-1.5,0s-.4,1.1,0,1.5c.2.2.5.3.8.3Z",
  fill: "#fff"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  d: "M364.9,194.7c.3,0,.5,0,.8-.3.4-.4.4-1.1,0-1.5s-1.1-.4-1.5,0c-.4.4-.4,1.1,0,1.5s.4.3.7.3Z",
  fill: "#fff"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  d: "M359.2,189.1c.3,0,.6,0,.8-.3.4-.4.4-1.1,0-1.5-.4-.4-1.1-.4-1.5,0s-.5,1.1,0,1.5c.2.2.5.3.7.3Z",
  fill: "#fff"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  d: "M353.4,183.7c.3,0,.6,0,.8-.3.4-.4.4-1.1,0-1.5-.4-.4-1.1-.4-1.5.1-.4.4-.4,1.1,0,1.5.2,0,.4.2.7.2Z",
  fill: "#fff"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  d: "M312.4,243.7c.8,0,1.5-.4,2-1.1.6-1.1.3-2.5-.8-3.1-1.1-.6-2.5-.3-3.2.8-.6,1.1-.3,2.5.8,3.1.4.2.8.3,1.2.3Z",
  fill: "#fff"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  d: "M347.5,178.3c.3,0,.6-.1.8-.4.4-.4.4-1.1,0-1.5-.4-.4-1.1-.4-1.5.1-.4.4-.4,1.1,0,1.5.2.3.4.3.7.3Z",
  fill: "#fff"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  d: "M341.5,173.1c.3,0,.6,0,.8-.4.4-.4.3-1.1,0-1.5s-1.1-.3-1.5,0c-.4.4-.3,1.1,0,1.5s.5.3.7.3Z",
  fill: "#fff"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  d: "M335.5,167.9c.3,0,.6,0,.8-.4.4-.5.3-1.1,0-1.5s-1.1-.3-1.5,0c-.4.5-.3,1.1,0,1.5s.4.3.7.3Z",
  fill: "#fff"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  d: "M84.9,109.2c-.4.5-.3,1.1.2,1.5.2.2.4.2.7.2s.6,0,.8-.4c.4-.5.3-1.1-.2-1.5-.4-.4-1.1-.3-1.5.2Z",
  fill: "#fff"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  d: "M252.2,106.6c.3,0,.7-.2.9-.5.3-.5.2-1.2-.3-1.5s-1.2-.2-1.5.3c-.4.5-.2,1.1.3,1.5.2.1.4.2.6.2Z",
  fill: "#fff"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  d: "M78.7,104.3c-.4.5-.3,1.1.2,1.5.2.2.4.2.7.2s.6-.1.8-.4c.4-.5.3-1.1-.2-1.5s-1.1-.3-1.5.2Z",
  fill: "#fff"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  d: "M244.9,102c.2,0,.4.2.6.2.4,0,.7-.2.9-.5.3-.5.2-1.2-.3-1.5-.5-.3-1.2-.2-1.5.3-.4.5-.2,1.2.3,1.5Z",
  fill: "#fff"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  d: "M72.5,99.3c-.4.5-.3,1.1.2,1.5.2.2.4.2.7.2s.6-.1.8-.4c.4-.5.3-1.1-.2-1.5s-1.1-.3-1.5.2Z",
  fill: "#fff"
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  d: "M238.2,97.7c.2.1.4.2.6.2.4,0,.7-.2.9-.5.3-.5.2-1.2-.3-1.5s-1.2-.2-1.5.3c-.4.5-.2,1.2.3,1.5Z",
  fill: "#fff"
})), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
  d: "M66.2,94.2c-.4.5-.3,1.1.1,1.5.2.2.4.2.7.2s.6,0,.8-.4c.4-.5.3-1.1-.1-1.5-.4-.3-1.1-.3-1.5.2Z",
  fill: "#fff"
})), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
  d: "M231.5,93.5c.2,0,.4.2.6.2.4,0,.7-.2.9-.5.3-.5.2-1.2-.3-1.5-.5-.3-1.2-.2-1.5.3-.4.5-.3,1.2.3,1.5Z",
  fill: "#fff"
})), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
  d: "M60.2,89c-.4.5-.3,1.1.1,1.5.2.2.4.3.7.3s.6-.1.8-.4c.4-.4.3-1.1-.1-1.5-.5-.4-1.2-.3-1.5.1Z",
  fill: "#fff"
})), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
  d: "M224.7,89.3c.2,0,.4.2.6.2.4,0,.7-.2.9-.5.3-.5.2-1.2-.4-1.5-.5-.3-1.2-.2-1.5.4-.3.4-.1,1.1.4,1.4Z",
  fill: "#fff"
})), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
  d: "M54.2,83.8c-.4.4-.3,1.1,0,1.5.2.2.5.3.7.3.3,0,.6,0,.8-.4.4-.4.3-1.1,0-1.5-.4-.4-1.1-.3-1.5.1Z",
  fill: "#fff"
})), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
  d: "M48.2,78.5c-.4.4-.4,1.1.1,1.5.2.2.5.3.7.3.3,0,.6-.1.8-.4.4-.4.4-1.1-.1-1.5-.4-.4-1.1-.3-1.5.1Z",
  fill: "#fff"
})), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
  d: "M42.5,73.1c-.4.4-.4,1.1,0,1.5.2.2.5.3.7.3.3,0,.6,0,.8-.3.4-.4.4-1.1,0-1.5-.4-.5-1.1-.4-1.5,0Z",
  fill: "#fff"
})), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
  d: "M36.7,67.6c-.4.4-.4,1.1,0,1.5s.5.3.7.3c.3,0,.6,0,.8-.3.4-.4.4-1.1,0-1.5-.4-.5-1.1-.5-1.5,0Z",
  fill: "#fff"
})), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
  d: "M31.1,61.9c-.4.4-.4,1.1,0,1.5.2.2.5.3.8.3s.5,0,.8-.3c.4-.4.4-1.1,0-1.5-.5-.4-1.2-.4-1.6,0Z",
  fill: "#fff"
})), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
  d: "M25.6,56.1c-.4.4-.5,1.1-.1,1.5.2.2.5.3.8.3s.5,0,.7-.3c.4-.4.5-1.1.1-1.5-.3-.4-1-.4-1.5,0Z",
  fill: "#fff"
})), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
  d: "M148.8,46.7c.2.1.3.1.5.1.4,0,.8-.2,1-.6.3-.5,0-1.2-.5-1.4-.5-.3-1.2-.1-1.4.5-.3.5,0,1.1.4,1.4Z",
  fill: "#fff"
})), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1,45.5c.2.3.5.4.8.4s.5,0,.7-.2c.5-.4.5-1,.2-1.5-.4-.5-1-.5-1.5-.2-.5.4-.6,1.1-.2,1.5Z",
  fill: "#fff"
})), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
  d: "M141.7,43.1c.2,0,.3,0,.5,0,.4,0,.8-.2,1-.6.3-.5,0-1.2-.5-1.4-.5-.3-1.2,0-1.4.5-.4.5-.2,1.2.4,1.4Z",
  fill: "#fff"
})), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
  d: "M134.5,39.6c.2,0,.3,0,.5,0,.4,0,.8-.2,1-.6.3-.5,0-1.2-.5-1.4-.5-.3-1.2,0-1.4.5-.3.5-.1,1.2.4,1.4Z",
  fill: "#fff"
})), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2,39.6c.2,0,.4,0,.6-.2.5-.3.6-1,.3-1.5-.3-.5-1-.6-1.5-.3-.6.4-.7,1-.3,1.5.2.3.5.5.9.5Z",
  fill: "#fff"
})), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
  d: "M127.2,36.2c.1.1.3.1.5.1.4,0,.8-.2,1-.6.3-.5,0-1.2-.5-1.4s-1.2,0-1.4.5c-.3.5-.1,1.2.4,1.4Z",
  fill: "#fff"
})), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
  d: "M120.1,32.9c0,.1.3.1.4.1.4,0,.8-.2,1-.6.2-.5,0-1.2-.5-1.4-.5-.2-1.2,0-1.4.5s0,1.1.5,1.4Z",
  fill: "#fff"
})), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
  d: "M6.7,32.9c.2,0,.4,0,.5-.2.5-.3.7-1,.4-1.5-.2-.4-.9-.6-1.4-.3s-.7,1-.4,1.5c.2.3.6.5.9.5Z",
  fill: "#fff"
})), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
  d: "M112.9,29.6c0,0,.3,0,.4,0,.4,0,.8-.2,1-.6.2-.5,0-1.2-.5-1.4-.5-.2-1.2,0-1.4.5-.3.5-.1,1.2.5,1.4Z",
  fill: "#fff"
})), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
  d: "M105.6,26.4c0,.1.3.1.4.1.4,0,.8-.2,1-.7.2-.5,0-1.2-.6-1.4-.5-.2-1.2,0-1.4.6-.2.6,0,1.2.6,1.4Z",
  fill: "#fff"
})), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
  d: "M3.1,25.9c0,0,.3,0,.4,0,.5-.2.8-.9.6-1.4-.2-.5-.9-.8-1.4-.6s-.8.9-.6,1.4c.2.4.6.7,1,.7Z",
  fill: "#fff"
})), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
  d: "M98.2,23.4c.1.1.3.1.4.1.4,0,.8-.2,1-.7s0-1.2-.6-1.4c-.5-.2-1.2,0-1.4.6-.3.5,0,1.1.6,1.4Z",
  fill: "#fff"
})), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
  d: "M90.9,20.4c0,.1.3.1.4.1.4,0,.8-.3,1-.7.2-.6,0-1.2-.6-1.4s-1.2.1-1.4.6c-.2.5,0,1.2.6,1.4Z",
  fill: "#fff"
})), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
  d: "M.6,16.2c-.6.1-1,.6-.9,1.2.1.5.5.9,1.1.9h.2c.6-.1,1-.6.9-1.2-.2-.6-.7-1-1.3-.9Z",
  fill: "#fff"
})), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
  d: "M83.5,17.5c.1,0,.3,0,.4,0,.4,0,.8-.3,1-.7.2-.6,0-1.2-.6-1.4-.6-.2-1.2,0-1.4.6-.3.6,0,1.2.6,1.4Z",
  fill: "#fff"
})), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
  d: "M76,14.8c.1,0,.2,0,.4,0,.4,0,.9-.3,1-.7.2-.6,0-1.2-.7-1.4-.6-.2-1.2,0-1.4.7-.1.5.2,1.1.7,1.3Z",
  fill: "#fff"
})), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
  d: "M68.5,12.2c.1,0,.2.1.3.1.5,0,.9-.3,1-.7.2-.6-.1-1.2-.7-1.4-.6-.2-1.2.1-1.4.7-.2.6.2,1.1.8,1.3Z",
  fill: "#fff"
})), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
  d: "M1,10.4c.1.1.3.1.4.1.4,0,.8-.2,1-.7s0-1.2-.6-1.4c-.5-.2-1.2,0-1.4.6-.2.5,0,1.1.6,1.4Z",
  fill: "#fff"
})), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
  d: "M60.9,9.8h.3c.5,0,.9-.3,1-.8.2-.6,0-1.2-.7-1.3-.6-.2-1.2.1-1.3.7,0,.6.2,1.2.7,1.4Z",
  fill: "#fff"
})), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
  d: "M53.2,7.6h.3c.5,0,.9-.3,1-.8.2-.6-.2-1.2-.8-1.3-.6-.2-1.2.2-1.3.8,0,.5.3,1.1.8,1.3Z",
  fill: "#fff"
})), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
  d: "M45.6,5.6h.2c.5,0,.9-.3,1-.8.1-.6-.2-1.2-.8-1.3-.6,0-1.2.2-1.3.8,0,.6.4,1.2.9,1.3Z",
  fill: "#fff"
})), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
  d: "M6.8,4.8c.2,0,.3,0,.5-.1.5-.3.7-1,.4-1.5s-.9-.7-1.4-.4-.7.9-.5,1.4c.2.4.6.6,1,.6Z",
  fill: "#fff"
})), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
  d: "M37.9,4h.2c.5,0,1-.4,1.1-.9,0-.6-.3-1.1-.9-1.3-.6-.2-1.1.3-1.3.9-.2.6.3,1.2.9,1.3Z",
  fill: "#fff"
})), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
  d: "M30.1,2.7h0c.5,0,1-.4,1.1-.9.1-.6-.3-1.1-.9-1.2-.6,0-1.1.3-1.2.9,0,.6.3,1.2.9,1.2Z",
  fill: "#fff"
})), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4,2.5h.2c.6-.1,1-.6.9-1.2,0-.6-.6-1-1.2-.9-.6.1-1,.6-.9,1.2,0,.5.4.9,1,.9Z",
  fill: "#fff"
})), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
  d: "M22.2,2.1c.6,0,1.1-.5,1.1-1S22.9,0,22.4,0s-1.1.5-1.1,1c0,.6.4,1.1,1,1.1Z",
  fill: "#fff"
})), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
  d: "M170.8,216.9l-.6.7c6,3.8,9.9,6,16.1,9.8,10.4,6.4,20.8,12.6,31.1,18.5l.6-.7c-10.3-5.9-20.7-12.1-31.2-18.5-6.1-3.9-10-6-16-9.8Z",
  fill: "#fff"
})), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
  d: "M382.7,258.3v-.2c0-.6-.5-1-1.1-1-5.9-6.9-13.1-14.4-21.6-22.4-11.6-10.9-30-25.5-44.8-37.2h0c-5.4-4.2-28.8-20.6-31.5-22.5h0c-5.9-4.1-11.9-8.1-18-12.1l-.8.6c6.2,4,12.2,8.1,18.1,12.2h0c1.9,1.3,26,18.2,31.6,22.5h0c14.8,11.7,33.2,26.2,44.7,37.2,8.3,7.9,15.5,15.3,21.4,22.1,0,.2-.2.4-.2.7,0,.6.5,1,1.1,1h0c.2,0,.3,0,.5,0,4.7,5.5,8.5,10.7,11.5,15.4,3.5,5.6,5.7,10.5,6.7,14.7s.6,7.8-1,10.4c-1.7,2.7-4.6,4.6-8.9,5.6-4.2,1-9.6,1.3-16.1.6-12.9-1.2-29.9-5.6-50.3-12.9-27.5-9.9-59.2-24.5-92.7-42.5.3-1,0-2-1-2.6-1.1-.6-2.5-.3-3.1.8-.6,1.1-.3,2.5.8,3.1.4.2.8.3,1.2.3.7,0,1.3-.3,1.7-.8,33.5,18,65.3,32.6,92.8,42.6,24.6,8.9,44,13.3,57.4,13.3s16.1-2.3,19-7.1c4.9-8-1.3-22.5-17.5-41.7Z",
  fill: "#fff"
})), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
  d: "M72.4,145.4c-10.1-8.3-19.5-16.5-27.8-24.4-15.9-15-27.4-28.2-34.3-39.2-3.5-5.6-5.7-10.5-6.7-14.7s-.6-7.8,1-10.4c1.7-2.7,4.6-4.6,8.9-5.6,2-.5,4.4-.8,7-.9,0,0,0,0,0,.1-.4.4-.5,1.1-.1,1.5.2.2.5.4.8.4s.5,0,.7-.3c.4-.4.5-1.1.1-1.5-.1,0-.2,0-.3-.2h1.3c2.1,0,4.4.1,6.8.3,12.9,1.2,29.9,5.6,50.3,12.9,31.3,11.3,78.3,33,118.5,55.2l.5-.8c-40.4-22.3-87.4-44.1-118.7-55.4C37.9,47.2,10.8,45,3.9,56.2c-6.9,11.2,7.3,34.5,40,65.4,8.4,8,17.8,16.2,28,24.6h0c1.2,1,29,22.5,49.4,35.8l.5-.8c-20.7-13.5-49.1-35.6-49.4-35.8h0Z",
  fill: "#fff"
})));
export { SvgBannerHi as ReactComponent };
export default __webpack_public_path__ + "d746e74f08ca85b8cb2f0499a228ca41.svg";